import Model from './Model'

export default class VideoEdit extends Model
{
    resource()
    {
        return 'video_edit'
    }
}
